<div
  class="fast-track-card"
  [ngClass]="policyClass"
  role="button"
  tabindex="0"
  [attr.aria-label]="card.name"
  [attr.aria-disabled]="card.unavailable ? true : null"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="fast-track-card__body">
    <div class="fast-track-card__icon" aria-hidden="true">
      <i class="ico-fast-track ico-material"></i>
    </div>

    <div class="fast-track-card__main">
      <div class="fast-track-card__name">{{ card.name }}</div>

      @if (card.terminal) {
        <div class="fast-track-card__terminal">
          <span i18n="@@chatFastTrackTerminal">Terminal</span> {{ card.terminal }}
        </div>
      }

      <div class="fast-track-card__meta">
        @if (card.isPreferred) {
          <span class="fast-track-card__preferred" i18n="@@chatFastTrackPreferred">Preferred</span>
        }
      </div>
    </div>

    <div class="fast-track-card__price-col">
      @if (!card.unavailable) {
        <span class="fast-track-card__price-label" i18n="@@totalPrice"> Total Price </span>
        <span class="fast-track-card__price">{{ formattedPrice }}</span>
      } @else {
        <span class="fast-track-card__unavailable-label" i18n="@@chatFastTrackUnavailableShort"
          >Unavailable</span
        >
      }
      <!-- Policy indicator: same component/tooltip as the results page,
           placed under the headline price per the travel-policy spec. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>
  </div>
</div>
